module.exports = __webpack_public_path__ + "static/img/bottom-line-red.69ff2f16.png";